import type { DocumentNode } from 'graphql';
import { mockMaps } from './maps';

export const mockFetch = (
  operationMehtod: 'query' | 'mutation',
  docs: DocumentNode,
  variables: AnyObject = {}
) => {
  const definitionsItem: AnyObject = docs.definitions[0];
  const operationDefinition = definitionsItem.name.value ?? '';

  const target = mockMaps[operationDefinition];

  if (!target) {
    return null;
  }

  const isQueryOperation = operationMehtod === 'query';

  const _variables = isQueryOperation ? variables.variables : variables;

  console.log(`mockFetch => `, {
    docs,
    variables: _variables,
    operationDefinition,
    isQueryOperation,
    target,
  });

  if (isQueryOperation) {
    return { data: { value: { [operationDefinition]: target(_variables) } } };
  } else {
    return { data: { [operationDefinition]: target(_variables) } };
  }
};
